<div *ngIf="item">
	<mat-card class="card-block">
		<mat-card-header>
			<mat-card-title>Händelser</mat-card-title>
			<div class="card-header-toolbar right"></div>
		</mat-card-header>
		<mat-card-content>
			<table class="table" *ngIf="!loading && !error">
				<tr *ngFor="let n of notes">
					<td>
						<div>{{n.created?.substring(0,10)}}</div>
						<div *ngIf="n.source"><i>{{n.source | capitalize}}</i></div>
					</td>
					<td>
						<div *ngIf="n.lead"><table-link path="leads" [entity]="n.lead"
								[title]="n.lead?.company || n.lead?.fullname"></table-link></div>
						<div *ngIf="n.fullname || n.email"><b>{{n.fullname}}</b>, {{n.email}}</div>
						<div class="note-message">{{n.message}}</div>
					</td>
					<td>
						<user-link [user]="n.agent"></user-link>
					</td>
				</tr>
			</table>
		</mat-card-content>
	</mat-card>
</div>